module.exports = __webpack_public_path__ + "static/assets/1bd3eaddaf1c3a237300ff6fcefec72a.png";